var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVerified(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1_41579)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.913574,
    y: 0.976318,
    width: 20,
    height: 20,
    rx: 10,
    fill: "white",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_41579)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2467 10.9763L16.6201 9.11632L16.8467 6.65632L14.4401 6.10965L13.1801 3.97632L10.9134 4.94965L8.64674 3.97632L7.38674 6.10299L4.98008 6.64299L5.20674 9.10965L3.58008 10.9763L5.20674 12.8363L4.98008 15.303L7.38674 15.8497L8.64674 17.9763L10.9134 16.9963L13.1801 17.9697L14.4401 15.843L16.8467 15.2963L16.6201 12.8363L18.2467 10.9763ZM9.16674 13.6497L7.58008 12.0497C7.32008 11.7897 7.32008 11.3697 7.58008 11.1097L7.62674 11.063C7.88674 10.803 8.31341 10.803 8.57341 11.063L9.64674 12.143L13.0801 8.70299C13.3401 8.44299 13.7667 8.44299 14.0267 8.70299L14.0734 8.74965C14.3334 9.00965 14.3334 9.42965 14.0734 9.68965L10.1267 13.6497C9.85341 13.9097 9.43341 13.9097 9.16674 13.6497Z",
    fill: "#6941C6"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1_41579",
    x: -15.0864,
    y: -15.0237,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1_41579"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1_41579",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_41579"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(2.91357 2.97632)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.9aba9efc01d3fef28d3b9985d2b00a44.svg";
export { ForwardRef as ReactComponent };